import React from 'react';
import './index.css';
import { BlueInfoIconTooltip } from '../../../components/common/CustomTooltip';
import UnicefIconTwo from './../../../assets/png/UNICEF Two.png'

interface LeftNavBarType {
  navItems: string[];
  currentTab: string;
  handleNavClick: (value: string) => void;
}

const LeftNavBarCommon = (props: LeftNavBarType) => {
  const { navItems, currentTab, handleNavClick } = props;

  return (
    <div className={`navbar-container`}>
      <ol>
        {navItems.map((item:any) => (
        <div className={`navbar-data`} key={item.label}>
          <li
            key={`${item.label}li`}
            className={`navbar-item ${currentTab === item.label ? 'active' : ''}`}
            onClick={() => handleNavClick(item.label)}
            style={item?.enable === false ? { pointerEvents: 'none' } :  {}}
          >
            {item.label}
          </li>
          {item?.enable === false  && (
            <BlueInfoIconTooltip text={item.tooltipMsg} style={{marginTop:'5%'}} />
          )}
        </div>
        ))}
      </ol>
      <img className='unicef-img-src-log-left-nav' src={UnicefIconTwo}/>
      </div>
  );
};
export default LeftNavBarCommon;
